import { Component, OnInit } from '@angular/core'
import {
  UntypedFormBuilder,
  Validators,
  UntypedFormControl,
} from '@angular/forms'
import { MessageService } from 'primeng/api'
import { ReportsService, ReportParamService } from '../../../../../api/services'
import { ReportsCategoryComponent } from '../../reports-category/reports-category.component'
import { Router, ActivatedRoute } from '@angular/router'
import { Globalattributes } from '../../../../../api/models'
import { validateAllFormFields } from '../../../../../formUtils'

@Component({
  selector: 'app-reportparam-add',
  templateUrl: './reportparam-add.component.html',
  styleUrls: ['./reportparam-add.component.css'],
})
export class ReportparamAddComponent implements OnInit {
  globalattributelist: Globalattributes[]
  addparamreport
  errorValidationSummary: string = ''
  reportId: number
  reportName: string
  ShowErrorSummary: boolean = false
  datatypes: { type: string; value: string }[]
  datatypesControl = new UntypedFormControl()
  stringdatatype: boolean = false
  numberdatatype: boolean = false
  datedatatype: boolean = false
  datetimedatatype: boolean = false
  timedatatype: boolean = false
  currencydatatype: boolean = false
  booleandatatype: boolean = false
  isglobalattribute: boolean = false
  isdatatypeattribute: boolean = true
  constructor(
    private fb: UntypedFormBuilder,
    private messageService: MessageService,
    private reportparamservice: ReportParamService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      let data = params
      this.reportId = data.report_Id
      this.reportName = data.report_Name
    })
    this.datatypes = [
      { type: 'Number', value: '0' },
      { type: 'String', value: '1' },
      { type: 'Date', value: '2' },
      { type: 'Boolean', value: '3' },
      { type: 'Currency', value: '4' },
      { type: 'DateTime', value: '5' },
      { type: 'Time', value: '6' },
    ]

    this.addparamreport = this.fb.group({
      reportName: [this.reportName, Validators.required],
      reportparamshortnote: ['', Validators.required],
      reportparamName: ['', Validators.required],
      isrequired: new UntypedFormControl(null, []),
      picklistValues: new UntypedFormControl('', []),
      datatype: new UntypedFormControl('', []),
      defaultvalue: new UntypedFormControl('', []),
      displayieldName: new UntypedFormControl('', []),
      endDateTime: new UntypedFormControl('', []),
      endTime: new UntypedFormControl('', []),
      isLookUp: new UntypedFormControl(null, []),
      maxCurrency: new UntypedFormControl('', []),
      maxdate: new UntypedFormControl('', []),
      maxnumber: new UntypedFormControl('', []),
      maxstringlength: new UntypedFormControl(null, []),
      minCurrency: new UntypedFormControl('', []),
      mindate: new UntypedFormControl('', []),
      minnumber: new UntypedFormControl('', []),
      startDateTime: new UntypedFormControl('', []),
      startTime: new UntypedFormControl('', []),
      tableName: new UntypedFormControl('', []),
      valueColumnName: new UntypedFormControl('', []),
    })

    this.LoadglobalAttributes()
  }
  //LoadglobalAttributes(): void {
  //  this.reportparamservice
  //    .reportParamGetglobalattributes({})
  //      .subscribe((result: { globalattributesSettings?: Array<Globalattributes> | null }) =>
  //      {

  //           this.globalattributelist = result.globalattributesSettings;

  //          //if (result.globalattributesSettings) {
  //          //    this.globalattributelist = result.globalattributesSettings.map(item => ({ ...item, settingName: item.settingName ? this.formatSettingName(item.settingName) : null }));
  //          //}


  //      // console.log(result);
  //    })
    //}

    LoadglobalAttributes(): void {
        this.reportparamservice
            .reportParamGetglobalattributes({})
            .subscribe((result) => {
                this.globalattributelist = result.globalattributesSettings
                // console.log(result);
            })
    }

    private formatSettingName(name: string): string
    {
        return name.replace(/([a-z])([A-Z])/g, '$1 $2');
    }


    setAttributes() {
    debugger
    if (this.addparamreport.value.isrequired) {
      this.isglobalattribute = true
      this.isdatatypeattribute = false
      this.stringdatatype = false
      this.numberdatatype = false
      this.datetimedatatype = false
      this.timedatatype = false
      this.datedatatype = false
      this.currencydatatype = false
    } else {
      this.isdatatypeattribute = true
      this.isglobalattribute = false
      this.SetDatatypeControls()
    }
  }
  SetDatatypeControls() {
    this.stringdatatype = false
    this.numberdatatype = false
    this.datetimedatatype = false
    this.timedatatype = false
    this.datedatatype = false
    this.currencydatatype = false
    debugger
    switch (this.addparamreport.value.datatype.value) {
      case '0':
        this.numberdatatype = true
        break
      case '1':
        this.stringdatatype = true

        break
      case '2':
        this.datedatatype = true
        break
      case 'Boolean':
        break
      case '4':
        this.currencydatatype = true
        break
      case '5':
        this.datetimedatatype = true
        break
      case '6':
        this.timedatatype = true
        break
      default:
        console.log('No case exists!')
        break
    }
  }
  saveParamReport() {
    validateAllFormFields(this.addparamreport)
    if (this.addparamreport.invalid) {
      return
    }
    debugger
    if (this.addparamreport.value.picklistValues != '') {
      this.addparamreport.value.picklistValues =
        this.addparamreport.value.picklistValues.settingValue + ''
    } else {
      this.addparamreport.value.picklistValues = ''
    }
    if (this.addparamreport.value.datatype != '') {
      this.addparamreport.value.datatype =
        this.addparamreport.value.datatype.value
    } else {
      this.addparamreport.value.datatype = ''
    }

    debugger
    this.reportparamservice
      .reportParamPost({
        body: this.addparamreport.value,
        reportId: this.reportId,
      })
      .subscribe(
        (val) => {
          if (val) {
            this.messageService.add({
              key: 'alertToast',
              severity: 'success',
              summary: 'Confirmation',
              detail: `Report param  saved successfully `,
              life: 5000,
            })
          }
          this.router.navigate(['administration/reports-param'], {
            queryParams: {
              report_Id: this.reportId,
              report_Name: this.reportName,
            },
            skipLocationChange: true,
          })
        },
        (err) => {
          this.messageService.add({
            key: 'alertToast',
            severity: 'error',
            summary: 'ERROR',
            detail: `error  in saving param `,
            life: 5000,
          })

          //console.log(err.error);
        },
      )
  }

  navigateToParamList(): void {
    debugger
    this.router.navigate(['administration/reports-param'], {
      queryParams: { report_Id: this.reportId, report_Name: this.reportName },
      skipLocationChange: true,
    })
  }
}
